import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { Select } from 'antd';
import { setSelectedDimension } from '@store/metricLens/base/actions';
import { dimensionsListSelector } from '@store/common/dimensionList/selectors';
import { selectedDimensionSelector } from '@store/metricLens/base/selectors';
import { track } from '@utils';
import { CLICK_ML_DIMENSION_CHANGE } from '@src/utils/sensor/track';
import { StyledSelector } from './styled';
import DimensionBetaLabel from '@src/components/dimension-panel-hz/dimensionSelectorPopup/DimensionBetaLabel';

function DimensionDropdown() {
  const dimension = useSelector(selectedDimensionSelector);

  const dispatch = useDispatch();

  const dimensionsList = useSelector(
    createSelector(
      dimensionsListSelector,
      selectedDimensionSelector,
      (dimensionList, selectedDimension) => {
        const options: any[] = [];
        dimensionList.forEach((d) => {
          options.push({
            value: d.groupBy,
            label: d.name,
          });
        });
        options.sort((a, b) => a.label.localeCompare(b.label));
        return options;
      },
    ),
  );

  const onChange = (value) => {
    dispatch(setSelectedDimension(value));
    track({ event: CLICK_ML_DIMENSION_CHANGE, data: { value } });
  };

  return (
    <StyledSelector>
      <Select
        showSearch
        optionFilterProp="label"
        optionRender={(option) => (
          <DimensionBetaLabel
            name={typeof option.label === 'string' ? option.label : ''}
            groupBy={String(option.value ?? '')}
          />
        )}
        options={dimensionsList}
        onChange={onChange}
        value={dimension}
        styles={{ popup: { root: { minWidth: 280 } } }}
        style={{
          width: 280,
          fontSize: '18px',
        }}
        variant="borderless"
      />
    </StyledSelector>
  );
}

export default DimensionDropdown;
